import React from "react";

export const CompanyPage: React.FC = () => {
  return (
    <div>
      <article className="prose prose-xl">
        {" "}
        <strong>株式会社LvUP</strong>
        <p>事業内容: インターネットサービス事業, ソフトウェアの開発及び販売</p>
        <p>設立: 平成24年8月28日</p>
        <p>資本金: 20万円</p>
        <p>代表者: 堤 健</p>
        <p>連絡先: lvupkk(アット)gmail.com</p>
      </article>
    </div>
  );
};
